import { MeetingMember } from './useMeetingMembers';

export interface RoomHostControlsVisibility {
    anyOtherAudioActive: boolean;
    anyOtherVideoActive: boolean;
    /** Whether literally everyone, self included, has audio/video off — for the "All muted"/"All cameras off" copy, which would otherwise overstate while the viewer's own track is still on. */
    everyoneAudioInactive: boolean;
    everyoneVideoInactive: boolean;
}

/**
 * Which room-wide host controls (VID-53 AC2) to offer, given the current members
 * and the active screen-sharer. A control is applicable only while some *other*
 * controllable participant has that track on: never self, never an audio-only
 * caller, and never the active screen-sharer — the latter is excluded to match
 * the server (which skips them when relaying), so the menu never offers an action
 * that would silently no-op.
 */
export const getRoomHostControlsVisibility = (
    members: MeetingMember[],
    screenShareMemberName: string | null,
): RoomHostControlsVisibility => {
    const isOtherControllableMember = (member: MeetingMember) =>
        !member.memberIsSelf &&
        !member.memberIsCaller &&
        member.name !== screenShareMemberName;

    return {
        anyOtherAudioActive: members.some(
            (member) => isOtherControllableMember(member) && member.audioActive,
        ),
        anyOtherVideoActive: members.some(
            (member) => isOtherControllableMember(member) && member.videoActive,
        ),
        everyoneAudioInactive: !members.some((member) => member.audioActive),
        everyoneVideoInactive: !members.some((member) => member.videoActive),
    };
};
